"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SVGTemplateResult = exports.TemplateResult = void 0;
const dom_js_1 = require("./dom.js");
const template_js_1 = require("./template.js");
const policy = window.trustedTypes &&
    trustedTypes.createPolicy('lit-html', { createHTML: (s) => s });
const commentMarker = ` ${template_js_1.marker} `;
class TemplateResult {
    constructor(strings, values, type, processor) {
        this.strings = strings;
        this.values = values;
        this.type = type;
        this.processor = processor;
    }
    getHTML() {
        const l = this.strings.length - 1;
        let html = '';
        let isCommentBinding = false;
        for (let i = 0; i < l; i++) {
            const s = this.strings[i];
            const commentOpen = s.lastIndexOf('<!--');
            isCommentBinding = (commentOpen > -1 || isCommentBinding) &&
                s.indexOf('-->', commentOpen + 1) === -1;
            const attributeMatch = template_js_1.lastAttributeNameRegex.exec(s);
            if (attributeMatch === null) {
                html += s + (isCommentBinding ? commentMarker : template_js_1.nodeMarker);
            }
            else {
                html += s.substr(0, attributeMatch.index) + attributeMatch[1] +
                    attributeMatch[2] + template_js_1.boundAttributeSuffix + attributeMatch[3] +
                    template_js_1.marker;
            }
        }
        html += this.strings[l];
        return html;
    }
    getTemplateElement() {
        const template = document.createElement('template');
        let value = this.getHTML();
        if (policy !== undefined) {
            value = policy.createHTML(value);
        }
        template.innerHTML = value;
        return template;
    }
}
exports.TemplateResult = TemplateResult;
class SVGTemplateResult extends TemplateResult {
    getHTML() {
        return `<svg>${super.getHTML()}</svg>`;
    }
    getTemplateElement() {
        const template = super.getTemplateElement();
        const content = template.content;
        const svgElement = content.firstChild;
        content.removeChild(svgElement);
        (0, dom_js_1.reparentNodes)(content, svgElement.firstChild);
        return template;
    }
}
exports.SVGTemplateResult = SVGTemplateResult;
